var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 960 200",
    width: 960,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 960,
    height: 200,
    fill: "#306db3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 120L22.8 108.8C45.7 97.7 91.3 75.3 137 65.7C182.7 56 228.3 59 274 67.2C319.7 75.3 365.3 88.7 411.2 90.7C457 92.7 503 83.3 548.8 86.8C594.7 90.3 640.3 106.7 686 113.3C731.7 120 777.3 117 823 108.3C868.7 99.7 914.3 85.3 937.2 78.2L960 71L960 201L937.2 201C914.3 201 868.7 201 823 201C777.3 201 731.7 201 686 201C640.3 201 594.7 201 548.8 201C503 201 457 201 411.2 201C365.3 201 319.7 201 274 201C228.3 201 182.7 201 137 201C91.3 201 45.7 201 22.8 201L0 201Z",
    fill: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "miter"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.6e55faa55652549226ad69548b61e327.svg";
export { ForwardRef as ReactComponent };